<template>
  <v-container>
    <v-select
      v-model="coordinateOrder"
      :items="items"
      item-text="name"
      item-value="id"
      label="Порядок координат"
      dense
      outlined
      :rules="[rules.required]"
    ></v-select>
  </v-container>
</template>

<script>
import WapiPresetSettings from "../../../models/contract/WapiPresetSettings.js";
import rules from "../../../models/helpers/rules.js";

export default {
  name: "WapiPresetSettingsSelect",
  props: {
    value: Object
  },
  data: function() {
    return {
      rules: rules,
      items: [
        {
          id: 1,
          name: "Широта;Долгота",
          value: [1, 0]
        },
        {
          id: 2,
          name: "Долгота;Широта",
          value: [0, 1]
        }
      ]
    };
  },
  computed: {
    coordinateOrder: {
      get: function() {
        if (!this.value?.coordinate_order) return null;
        const findValue =
          this.items.find(
            x =>
              x.value[0] == this.value.coordinate_order[0] &&
              x.value[1] == this.value.coordinate_order[1]
          ).id || this.items[0].id;
        return findValue;
      },
      set: function(value) {
        const newVal = this.items.find(x => x.id === value).value;
        const setttings = new WapiPresetSettings();
        setttings.coordinate_order = newVal;
        this.$emit("input", setttings);
      }
    }
  }
};
</script>